<script>
  let { assetsPath = '/', onAiMounted = () => {} } = $props();
  import { onMount } from 'svelte';
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-attack-map-box">
  <!-- Artboard: xs -->
  <div
    id="g-attack-map-xs"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.2406015037594;"
  >
    <div
      id="g-attack-map-xs-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/attack-map-xs.jpg);"
    ></div>
    <div
      id="g-ai0-1"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:10.1184%;margin-top:-4.9px;left:89.5324%;margin-left:-48px;width:96px;"
    >
      <p class="g-pstyle0">Uzbekistan</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:22.5245%;margin-top:-4.9px;left:19.1063%;margin-left:-33.5px;width:67px;"
    >
      <p class="g-pstyle0">TURKEY</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:27.0357%;margin-top:-4.9px;left:83.7749%;margin-left:-57.5px;width:115px;"
    >
      <p class="g-pstyle0">Turkmenistan</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:32.1109%;margin-top:-3.4px;left:49.6502%;width:47px;"
    >
      <p class="g-pstyle1">Tabriz</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:38.8778%;margin-top:-3.4px;right:15.679%;width:61px;"
    >
      <p class="g-pstyle2">Mashhad</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:42.4649%;margin-top:-4px;left:64.0644%;width:54px;"
    >
      <p class="g-pstyle3">Tehran</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:43.5771%;margin-top:-4.9px;left:26.3524%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle0">Syria</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:46.0207%;margin-top:-3.4px;left:55.2603%;width:63px;"
    >
      <p class="g-pstyle1">Hamadan</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:48.2763%;margin-top:-6.4px;left:19.176%;width:89px;"
    >
      <p class="g-pstyle4">Iranian airstrike</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:50.2184%;margin-top:-5.6px;right:84.523%;width:71px;"
    >
      <p class="g-pstyle5">Israel</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:50.9079%;margin-top:-3.4px;left:64.368%;width:117px;"
    >
      <p class="g-pstyle1">Natanz Nuclear facility</p>
    </div>
    <div
      id="g-ai0-12"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:53.3515%;margin-top:-4.9px;left:38.7453%;margin-left:-25px;width:50px;"
    >
      <p class="g-pstyle0">Iraq</p>
    </div>
    <div
      id="g-ai0-13"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:53.7431%;margin-top:-4px;left:15.1589%;width:59px;"
    >
      <p class="g-pstyle3">Tel-Aviv</p>
    </div>
    <div
      id="g-ai0-14"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:55.0432%;margin-top:-3.4px;left:64.368%;width:53px;"
    >
      <p class="g-pstyle1">Isfahan</p>
    </div>
    <div
      id="g-ai0-15"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:58.4891%;margin-top:-5.6px;left:76.1714%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle6">Iran</p>
    </div>
    <div
      id="g-ai0-16"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:58.4267%;margin-top:-6.4px;right:48.7598%;width:85px;"
    >
      <p class="g-pstyle7">Israeli airstrike</p>
    </div>
    <div
      id="g-ai0-17"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:60.8703%;margin-top:-4.9px;left:15.1562%;width:69px;"
    >
      <p class="g-pstyle8">Jordan</p>
    </div>
    <div
      id="g-ai0-18"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:67.8252%;margin-top:-3.4px;left:66.9401%;width:48px;"
    >
      <p class="g-pstyle1">Shiraz</p>
    </div>
    <div
      id="g-ai0-19"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:82.186%;margin-top:-9.6px;left:38.8121%;margin-left:-33px;width:66px;"
    >
      <p class="g-pstyle0">Saudi</p>
      <p class="g-pstyle0">Arabia</p>
    </div>
  </div>

  <!-- Artboard: sm -->
  <div
    id="g-attack-map-sm"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.29113924050633;"
  >
    <div
      id="g-attack-map-sm-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/attack-map-sm.jpg);"
    ></div>
    <div
      id="g-ai1-1"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:11.0122%;margin-top:-7.5px;left:89.3903%;margin-left:-55.5px;width:111px;"
    >
      <p class="g-pstyle0">Uzbekistan</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:23.1641%;margin-top:-7.5px;left:20.2265%;margin-left:-38.5px;width:77px;"
    >
      <p class="g-pstyle0">TURKEY</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:27.9742%;margin-top:-7.5px;left:83.7459%;margin-left:-67px;width:134px;"
    >
      <p class="g-pstyle0">Turkmenistan</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:33.4172%;margin-top:-5px;left:50.1504%;width:52px;"
    >
      <p class="g-pstyle1">Tabriz</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:40.2527%;margin-top:-5px;right:15.731%;width:69px;"
    >
      <p class="g-pstyle2">Mashhad</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:44.0712%;margin-top:-6.1px;left:64.325%;width:63px;"
    >
      <p class="g-pstyle3">Tehran</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:44.9362%;margin-top:-7.5px;left:27.2685%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle0">Syria</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:47.5944%;margin-top:-5px;left:55.6671%;width:71px;"
    >
      <p class="g-pstyle1">Hamadan</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:49.3666%;margin-top:-5px;right:49.4934%;width:86px;"
    >
      <p class="g-pstyle2">Kermanshah</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:49.9995%;margin-top:-7.5px;left:20.1826%;width:103px;"
    >
      <p class="g-pstyle4">Iranian airstrike</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:52.1934%;margin-top:-8.2px;right:83.4754%;width:92px;"
    >
      <p class="g-pstyle5">Israel</p>
    </div>
    <div
      id="g-ai1-12"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:52.6577%;margin-top:-5px;left:64.6235%;width:136px;"
    >
      <p class="g-pstyle1">Natanz Nuclear facility</p>
    </div>
    <div
      id="g-ai1-13"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:54.8096%;margin-top:-7.5px;left:39.4675%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle0">Iraq</p>
    </div>
    <div
      id="g-ai1-14"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:55.2104%;margin-top:-6.1px;left:16.2323%;width:69px;"
    >
      <p class="g-pstyle3">Tel-Aviv</p>
    </div>
    <div
      id="g-ai1-15"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:56.9615%;margin-top:-5px;left:64.6235%;width:59px;"
    >
      <p class="g-pstyle1">Isfahan</p>
    </div>
    <div
      id="g-ai1-16"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:60.5478%;margin-top:-8.2px;left:76.3188%;margin-left:-35px;width:70px;"
    >
      <p class="g-pstyle6">Iran</p>
    </div>
    <div
      id="g-ai1-17"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:60.1261%;margin-top:-7.5px;right:48.1901%;width:98px;"
    >
      <p class="g-pstyle7">Israeli airstrike</p>
    </div>
    <div
      id="g-ai1-18"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:62.6577%;margin-top:-7.5px;left:16.2297%;width:78px;"
    >
      <p class="g-pstyle8">Jordan</p>
    </div>
    <div
      id="g-ai1-19"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:69.8729%;margin-top:-5px;left:67.1529%;width:54px;"
    >
      <p class="g-pstyle1">Shiraz</p>
    </div>
    <div
      id="g-ai1-20"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:84.7191%;margin-top:-14.6px;left:39.5081%;margin-left:-37.5px;width:75px;"
    >
      <p class="g-pstyle0">Saudi</p>
      <p class="g-pstyle0">Arabia</p>
    </div>
  </div>

  <!-- Artboard: md -->
  <div
    id="g-attack-map-md"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.46341463414634;"
  >
    <div
      id="g-attack-map-md-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/attack-map-md.jpg);"
    ></div>
    <div
      id="g-ai2-1"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:10.9752%;margin-top:-8.5px;left:82.4908%;margin-left:-55.5px;width:111px;"
    >
      <p class="g-pstyle0">Uzbekistan</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:22.9486%;margin-top:-8.5px;left:24.0153%;margin-left:-38.5px;width:77px;"
    >
      <p class="g-pstyle0">TURKEY</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:27.3832%;margin-top:-8.5px;left:77.7168%;margin-left:-67px;width:134px;"
    >
      <p class="g-pstyle0">Turkmenistan</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:32.4829%;margin-top:-5.5px;left:49.3173%;width:52px;"
    >
      <p class="g-pstyle1">Tabriz</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:38.9131%;margin-top:-5.5px;right:21.8448%;width:69px;"
    >
      <p class="g-pstyle2">Mashhad</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:42.6917%;margin-top:-6.5px;left:61.3009%;width:60px;"
    >
      <p class="g-pstyle3">Tehran</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:43.5694%;margin-top:-8.5px;left:29.9729%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle0">Syria</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:46.2302%;margin-top:-5.5px;left:53.9813%;width:71px;"
    >
      <p class="g-pstyle1">Hamadan</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:48.004%;margin-top:-5.5px;right:50.3883%;width:86px;"
    >
      <p class="g-pstyle2">Kermanshah</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:48.1333%;margin-top:-9.1px;left:23.9813%;width:116px;"
    >
      <p class="g-pstyle4">Iranian airstrike</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:49.5561%;margin-top:-8.5px;left:92.0141%;margin-left:-61.5px;width:123px;"
    >
      <p class="g-pstyle0">Afghanistan</p>
    </div>
    <div
      id="g-ai2-12"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:50.5907%;margin-top:-9.2px;right:79.1159%;width:92px;"
    >
      <p class="g-pstyle5">Israel</p>
    </div>
    <div
      id="g-ai2-13"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:51.1082%;margin-top:-5.5px;left:61.5533%;width:136px;"
    >
      <p class="g-pstyle1">Natanz Nuclear facility</p>
    </div>
    <div
      id="g-ai2-14"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:53.113%;margin-top:-6.5px;left:20.6416%;width:65px;"
    >
      <p class="g-pstyle3">Tel-Aviv</p>
    </div>
    <div
      id="g-ai2-15"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:53.1038%;margin-top:-8.5px;left:40.2829%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle0">Iraq</p>
    </div>
    <div
      id="g-ai2-16"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:55.0993%;margin-top:-5.5px;left:61.5533%;width:59px;"
    >
      <p class="g-pstyle1">Isfahan</p>
    </div>
    <div
      id="g-ai2-17"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:58.1111%;margin-top:-9.1px;right:49.2285%;width:111px;"
    >
      <p class="g-pstyle6">Israeli airstrike</p>
    </div>
    <div
      id="g-ai2-18"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:58.5729%;margin-top:-9.2px;left:71.439%;margin-left:-35px;width:70px;"
    >
      <p class="g-pstyle7">Iran</p>
    </div>
    <div
      id="g-ai2-19"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:60.6426%;margin-top:-8.5px;left:20.6394%;width:78px;"
    >
      <p class="g-pstyle8">Jordan</p>
    </div>
    <div
      id="g-ai2-20"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:67.5162%;margin-top:-5.5px;left:63.6917%;width:54px;"
    >
      <p class="g-pstyle1">Shiraz</p>
    </div>
    <div
      id="g-ai2-21"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:69.29%;margin-top:-8.5px;right:0.5528%;width:91px;"
    >
      <p class="g-pstyle9">Pakistan</p>
    </div>
    <div
      id="g-ai2-22"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:81.6658%;margin-top:-16.3px;left:40.3174%;margin-left:-37.5px;width:75px;"
    >
      <p class="g-pstyle0">Saudi</p>
      <p class="g-pstyle0">Arabia</p>
    </div>
  </div>

  <!-- Artboard: lg -->
  <div
    id="g-attack-map-lg"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.74812030075188;"
  >
    <div
      id="g-attack-map-lg-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/attack-map-lg.jpg);"
    ></div>
    <div
      id="g-ai3-1"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:10.9175%;margin-top:-10.1px;left:75.1148%;margin-left:-63px;width:126px;"
    >
      <p class="g-pstyle0">Uzbekistan</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:23.6994%;margin-top:-10.1px;left:24.1052%;margin-left:-43px;width:86px;"
    >
      <p class="g-pstyle0">TURKEY</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:27.4588%;margin-top:-10.1px;left:71.0018%;margin-left:-76px;width:152px;"
    >
      <p class="g-pstyle0">Turkmenistan</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:32.816%;margin-top:-6.6px;left:46.8415%;width:57px;"
    >
      <p class="g-pstyle1">Tabriz</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:39.3949%;margin-top:-6.6px;right:28.6793%;width:76px;"
    >
      <p class="g-pstyle2">Mashhad</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:43.3423%;margin-top:-7.6px;left:57.0518%;width:63px;"
    >
      <p class="g-pstyle3">Tehran</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:44.1882%;margin-top:-10.1px;left:30.3689%;margin-left:-35px;width:70px;"
    >
      <p class="g-pstyle0">Syria</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:46.7258%;margin-top:-6.6px;left:50.8153%;width:80px;"
    >
      <p class="g-pstyle1">Hamadan</p>
    </div>
    <div
      id="g-ai3-9"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:48.6055%;margin-top:-6.6px;right:52.981%;width:96px;"
    >
      <p class="g-pstyle2">Kermanshah</p>
    </div>
    <div
      id="g-ai3-10"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:48.8874%;margin-top:-9.1px;left:25.2547%;width:116px;"
    >
      <p class="g-pstyle4">Iranian airstrike</p>
    </div>
    <div
      id="g-ai3-11"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:50.2032%;margin-top:-10.1px;left:83.2287%;margin-left:-70px;width:140px;"
    >
      <p class="g-pstyle0">Afghanistan</p>
    </div>
    <div
      id="g-ai3-12"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:51.4562%;margin-top:-10.7px;right:77.3384%;width:100px;"
    >
      <p class="g-pstyle5">Israel</p>
    </div>
    <div
      id="g-ai3-13"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:51.613%;margin-top:-6.6px;left:57.2669%;width:155px;"
    >
      <p class="g-pstyle1">Natanz Nuclear facility</p>
    </div>
    <div
      id="g-ai3-14"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:53.7746%;margin-top:-10.1px;left:39.1075%;margin-left:-30.5px;width:61px;"
    >
      <p class="g-pstyle0">Iraq</p>
    </div>
    <div
      id="g-ai3-15"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:53.8686%;margin-top:-7.6px;left:22.4091%;width:69px;"
    >
      <p class="g-pstyle3">Tel-Aviv</p>
    </div>
    <div
      id="g-ai3-16"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:55.7483%;margin-top:-6.6px;left:57.2669%;width:65px;"
    >
      <p class="g-pstyle1">Isfahan</p>
    </div>
    <div
      id="g-ai3-17"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:59.5389%;margin-top:-10.7px;left:65.6885%;margin-left:-38px;width:76px;"
    >
      <p class="g-pstyle6">Iran</p>
    </div>
    <div
      id="g-ai3-18"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:59.0378%;margin-top:-9.1px;right:51.9282%;width:111px;"
    >
      <p class="g-pstyle7">Israeli airstrike</p>
    </div>
    <div
      id="g-ai3-19"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:61.4814%;margin-top:-10.1px;left:22.4073%;width:87px;"
    >
      <p class="g-pstyle8">Jordan</p>
    </div>
    <div
      id="g-ai3-20"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:68.3423%;margin-top:-6.6px;left:59.0889%;width:59px;"
    >
      <p class="g-pstyle1">Shiraz</p>
    </div>
    <div
      id="g-ai3-21"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:73.1355%;margin-top:-10.1px;left:87.7767%;margin-left:-51.5px;width:103px;"
    >
      <p class="g-pstyle0">Pakistan</p>
    </div>
    <div
      id="g-ai3-22"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:82.7938%;margin-top:-19.5px;left:39.1278%;margin-left:-41.5px;width:83px;"
    >
      <p class="g-pstyle0">Saudi</p>
      <p class="g-pstyle0">Arabia</p>
    </div>
  </div>
</div>
<!-- End ai2html - 2025-06-17 13:53 -->

<!-- Generated by ai2html v0.101.0 - 2025-06-17 13:53 -->
<!-- ai file: attack-map.ai -->
<style lang="scss">
  #g-attack-map-box,
  #g-attack-map-box .g-artboard {
    margin: 0 auto;
  }
  #g-attack-map-box p {
    margin: 0;
  }
  #g-attack-map-box .g-aiAbs {
    position: absolute;
  }
  #g-attack-map-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-attack-map-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-attack-map-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-attack-map-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-attack-map-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-attack-map-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-attack-map-lg {
        display: block !important;
      }
    }
  }
  #g-attack-map-xs {
    position: relative;
    overflow: hidden;
  }
  #g-attack-map-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 6px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 10px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-attack-map-xs .g-pstyle0 {
    line-height: 9px;
    height: 9px;
    letter-spacing: 0.2em;
    text-align: center;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-attack-map-xs .g-pstyle1 {
    height: 6px;
  }
  #g-attack-map-xs .g-pstyle2 {
    height: 6px;
    text-align: right;
  }
  #g-attack-map-xs .g-pstyle3 {
    font-weight: 500;
    line-height: 7px;
    height: 7px;
    font-size: 11px;
    color: rgb(0, 0, 0);
  }
  #g-attack-map-xs .g-pstyle4 {
    font-weight: 500;
    line-height: 12px;
    height: 12px;
    color: rgb(0, 0, 0);
  }
  #g-attack-map-xs .g-pstyle5 {
    font-weight: 900;
    line-height: 10px;
    height: 10px;
    letter-spacing: 0.025em;
    font-size: 14px;
    text-align: right;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-attack-map-xs .g-pstyle6 {
    font-weight: 900;
    line-height: 10px;
    height: 10px;
    letter-spacing: 0.025em;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-attack-map-xs .g-pstyle7 {
    font-weight: 500;
    line-height: 12px;
    height: 12px;
    text-align: right;
    color: rgb(165, 15, 21);
  }
  #g-attack-map-xs .g-pstyle8 {
    line-height: 9px;
    height: 9px;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-attack-map-sm {
    position: relative;
    overflow: hidden;
  }
  #g-attack-map-sm p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 9px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-attack-map-sm .g-pstyle0 {
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    text-align: center;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-attack-map-sm .g-pstyle1 {
    height: 9px;
  }
  #g-attack-map-sm .g-pstyle2 {
    height: 9px;
    text-align: right;
  }
  #g-attack-map-sm .g-pstyle3 {
    font-weight: 500;
    line-height: 11px;
    height: 11px;
    font-size: 14px;
    color: rgb(0, 0, 0);
  }
  #g-attack-map-sm .g-pstyle4 {
    font-weight: 500;
    line-height: 14px;
    height: 14px;
    color: rgb(0, 0, 0);
  }
  #g-attack-map-sm .g-pstyle5 {
    font-weight: 900;
    line-height: 15px;
    height: 15px;
    letter-spacing: 0.2em;
    font-size: 16px;
    text-align: right;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-attack-map-sm .g-pstyle6 {
    font-weight: 900;
    line-height: 15px;
    height: 15px;
    letter-spacing: 0.2em;
    font-size: 16px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-attack-map-sm .g-pstyle7 {
    font-weight: 500;
    line-height: 14px;
    height: 14px;
    text-align: right;
    color: rgb(165, 15, 21);
  }
  #g-attack-map-sm .g-pstyle8 {
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: rgb(153, 153, 153);
  }
  #g-attack-map-md {
    position: relative;
    overflow: hidden;
  }
  #g-attack-map-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 16px;
    height: auto;
    opacity: 1;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: left;
    text-transform: none;
    color: rgb(153, 153, 153);
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-attack-map-md .g-pstyle0 {
    height: 16px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-attack-map-md .g-pstyle1 {
    line-height: 10px;
    height: 10px;
    letter-spacing: 0em;
    color: rgb(64, 64, 64);
  }
  #g-attack-map-md .g-pstyle2 {
    line-height: 10px;
    height: 10px;
    letter-spacing: 0em;
    text-align: right;
    color: rgb(64, 64, 64);
  }
  #g-attack-map-md .g-pstyle3 {
    font-weight: 500;
    line-height: 12px;
    height: 12px;
    letter-spacing: 0em;
    font-size: 13px;
    color: rgb(0, 0, 0);
  }
  #g-attack-map-md .g-pstyle4 {
    font-weight: 500;
    line-height: 17px;
    height: 17px;
    letter-spacing: 0em;
    font-size: 14px;
    color: rgb(0, 0, 0);
  }
  #g-attack-map-md .g-pstyle5 {
    font-weight: 900;
    line-height: 17px;
    height: 17px;
    font-size: 16px;
    text-align: right;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-attack-map-md .g-pstyle6 {
    font-weight: 500;
    line-height: 17px;
    height: 17px;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: right;
    color: rgb(165, 15, 21);
  }
  #g-attack-map-md .g-pstyle7 {
    font-weight: 900;
    line-height: 17px;
    height: 17px;
    font-size: 16px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-attack-map-md .g-pstyle8 {
    height: 16px;
    text-transform: uppercase;
  }
  #g-attack-map-md .g-pstyle9 {
    height: 16px;
    text-align: right;
    text-transform: uppercase;
  }
  #g-attack-map-lg {
    position: relative;
    overflow: hidden;
  }
  #g-attack-map-lg p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 19px;
    height: auto;
    opacity: 1;
    letter-spacing: 0.2em;
    font-size: 14px;
    text-align: left;
    text-transform: none;
    color: rgb(153, 153, 153);
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-attack-map-lg .g-pstyle0 {
    height: 19px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-attack-map-lg .g-pstyle1 {
    line-height: 12px;
    height: 12px;
    letter-spacing: 0em;
    color: rgb(64, 64, 64);
  }
  #g-attack-map-lg .g-pstyle2 {
    line-height: 12px;
    height: 12px;
    letter-spacing: 0em;
    text-align: right;
    color: rgb(64, 64, 64);
  }
  #g-attack-map-lg .g-pstyle3 {
    font-weight: 500;
    line-height: 14px;
    height: 14px;
    letter-spacing: 0em;
    color: rgb(0, 0, 0);
  }
  #g-attack-map-lg .g-pstyle4 {
    font-weight: 500;
    line-height: 17px;
    height: 17px;
    letter-spacing: 0em;
    color: rgb(0, 0, 0);
  }
  #g-attack-map-lg .g-pstyle5 {
    font-weight: 900;
    line-height: 20px;
    height: 20px;
    font-size: 18px;
    text-align: right;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-attack-map-lg .g-pstyle6 {
    font-weight: 900;
    line-height: 20px;
    height: 20px;
    font-size: 18px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-attack-map-lg .g-pstyle7 {
    font-weight: 500;
    line-height: 17px;
    height: 17px;
    letter-spacing: 0em;
    text-align: right;
    color: rgb(165, 15, 21);
  }
  #g-attack-map-lg .g-pstyle8 {
    height: 19px;
    text-transform: uppercase;
  }

  /* Custom CSS */
  .g-text {
  }
</style>
